import React, { useEffect } from "react";
import Navbar from "../components/Navbar";
import { Link, useLocation } from "react-router-dom";
import AboutImage from "../assets/img/premium_photo-1682096259050-361e2989706d 1.png";
import Realisation from "../assets/img/Réalisation2.png";
import Footer from "../components/Footer";
import { Helmet } from "react-helmet-async";

const Services = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div>
      <Helmet>
        <title>Mes services – Peinture intérieure et extérieure à Vannes</title>
        <meta
          name="description"
          content="LM Couleurs propose des services de peinture intérieure, décoration murale et rénovation complète dans tout le Morbihan."
        />
        <link rel="canonical" href="https://lmcouleurs.fr" />
        <meta
          property="og:title"
          content="Nos services – Peinture & décoration à Vannes"
        />
        <meta
          property="og:description"
          content="Peinture intérieure, enduit décoratif, papier peint… Découvrez tous les services proposés par LM Couleurs dans le Morbihan."
        />
        <meta property="og:url" content="https://lmcouleurs.fr/services" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://lmcouleurs.fr/images/og-services.jpg"
        />
      </Helmet>

      <Navbar />
      <div className="services">
        <h1>Mes Services</h1>
        <p>
          Chaque projet mérite toute mon attention. En tant qu'artisan peintre
          indépendant, je m'engage à vous offrir un accompagnement personnalisé
          à chaque étape de votre projet.
        </p>

        <div className="services-cards">
          <div className="neuf">
            <div className="card-text">
              <h3>Neuf & Rénovation</h3>
              <p>
                Peinture pour constructions neuves ou rénovation intérieure.
                Préparation des supports et finitions durables.
              </p>

              <a href="#neuf">En savoir plus</a>
            </div>
          </div>
          <div className="enduit">
            <div className="card-text">
              <h3>Enduit</h3>
              <p>
                Application d’enduits décoratifs ou de lissage pour corriger les
                défauts et créer des murs élégants, avec une finition nette et
                durable.
              </p>
              <a href="#enduit">En savoir plus</a>
            </div>
          </div>
          <div className="papier-peint">
            <div className="card-text">
              <h3>Papier Peint</h3>
              <p>
                Pose de papier peint avec précision : panoramique, intissé ou
                vinyle, pour apporter style et caractère à vos espaces.
              </p>
              <a href="#papier-peint">En savoir plus</a>
            </div>
          </div>
        </div>
        <div className="neuf-about" id="neuf">
          <div className="neuf-about-header">
            <h2>Peinture</h2>
            <p>Des murs propres, des finitions nettes, un résultat durable.</p>
          </div>
          <div className="neuf-about-text-2">
            <p>
              Je réalise tous vos travaux de peinture intérieure, que ce soit
              pour un logement neuf ou en rénovation. J’interviens sur les{" "}
              <strong>murs, plafonds, boiseries, portes</strong> et autres
              supports, avec une attention particulière portée à la{" "}
              <strong>préparation</strong>. <br />
              <br />
              Avant toute mise en peinture,{" "}
              <strong>les surfaces sont protégées</strong>, nettoyées et
              préparées afin d’assurer une finition nette et durable. J’utilise
              des peintures de qualité, adaptées à chaque pièce, pour un{" "}
              <strong>rendu esthétique et facile d’entretien</strong>. <br />
              <br />
              Mon objectif est de vous offrir un intérieur{" "}
              <strong>propre, lumineux et harmonieux</strong>, tout en
              garantissant un chantier organisé et sans stress.
            </p>
            <div className="neuf-about-img">
              <p>Neuf</p>
            </div>
          </div>
          <div className="neuf-about-text-1" id="neuf-text-1">
            <div className="neuf-about-img">
              <p>Neuf</p>
            </div>
            <p>
              En rénovation, la préparation est une étape clé. Je prends en
              charge la reprise de{" "}
              <strong>
                supports abîmés, fissurés ou marqués par le temps.
              </strong>{" "}
              <br />
              <br />
              Les travaux incluent{" "}
              <strong>
                ponçage, enduits, lissage et corrections des défauts
              </strong>{" "}
              afin de repartir sur des bases saines. Cette étape garantit un
              <strong>résultat final propre et durable</strong>. <br />
              <br />
              Chaque chantier est étudié avec attention afin de proposer une
              solution adaptée à l’état des supports et à vos attentes.
            </p>
          </div>
        </div>

        <div className="enduit-about" id="enduit">
          <div className="enduit-about-header">
            <h2>Enduit décoratif</h2>
            <p>Du caractère et du style, posés avec précision.</p>
          </div>
          <div className="enduit-about-text-1" id="enduit-text-1">
            <p>
              Les enduits décoratifs apportent du caractère et une vraie
              identité à votre intérieur. Ils permettent de{" "}
              <strong>créer des effets de matière</strong>, de relief ou de
              texture, tout en donnant de la{" "}
              <strong>profondeur aux murs</strong>.
              <br />
              <br />
              Chaque projet est étudié en fonction de l’ambiance recherchée, du
              support existant et de la pièce concernée.
              <br />
              <br />
              <strong>
                Quel est l’intérêt d’un enduit décoratif par rapport à une
                peinture classique ?
              </strong>
              <br />
              <br />
              L’enduit décoratif offre un rendu plus vivant et plus
              <strong> personnalisé</strong>, tout en masquant certaines
              imperfections du support.
            </p>
            <div className="enduit-about-img">
              <p>Enduit</p>
            </div>
          </div>
          <div className="enduit-about-text-1">
            <div className="enduit-about-img">
              <p>Enduit</p>
            </div>
            <p>
              Au‑delà de l’aspect esthétique, les enduits décoratifs sont une
              solution durable et résistante. <br />
              <br />
              Ils permettent d’obtenir une{" "}
              <strong>finition soignée et homogène</strong>, adaptée aussi bien
              aux pièces de vie qu’aux espaces plus sollicités.
              <br />
              <br />
              L’application est réalisée avec précision pour garantir un{" "}
              <strong>
                rendu élégant, équilibré et facile à entretenir
              </strong>{" "}
              dans le temps.
            </p>
          </div>
        </div>
        <div className="papier-peint-about" id="papier-peint">
          <div className="papier-peint-about-header">
            <h2>Papier Peint</h2>
            <p>
              Du relief, de la matière et une finition qui fait la différence.
            </p>
          </div>

          <div className="papier-peint-about-text-1" id="papier-peint-text-1">
            <p>
              Je réalise la pose de papiers peints{" "}
              <strong>classiques, intissés ou panoramiques</strong>, en neuf
              comme en rénovation. <br />
              <br />
              Les murs sont préparés avec soin afin d’assurer une parfaite
              adhérence et des raccords précis. <br />
              <br />
              Chaque pose est réalisée avec minutie pour obtenir un rendu
              propre, régulier et esthétique. <br />
              <br />
              <strong>
                Pourquoi choisir le papier peint plutôt qu’une simple peinture ?
              </strong>
              <br />
              <br />
              Le papier peint permet de structurer un espace, d’apporter du
              caractère et de créer une ambiance unique, tout en mettant en
              valeur les volumes et les murs.
            </p>
            <div className="papier-peint-about-img">
              <p>Papier Peint</p>
            </div>
          </div>
          <div className="papier-peint-about-text-1">
            <div className="papier-peint-about-img">
              <p>Papier Peint</p>
            </div>
            <p>
              Au‑delà de l’aspect décoratif, une pose de papier peint réussie
              repose sur une préparation rigoureuse des supports. <br />
              <br />
              Cette étape garantit une finition durable, sans bulles ni défauts
              visibles, et un rendu homogène dans le temps. <br />
              <br />
              C’est une solution idéale pour personnaliser un intérieur,
              souligner un mur ou donner du style à une pièce sans la
              surcharger.
            </p>
          </div>
        </div>

        <div className="services-about" id="about">
          <div className="services-about-text">
            <h2>Qui suis-je ?</h2>
            <p>
              <p>
                Je m'appelle <strong>Maxime</strong>,
                <strong> artisan peintre spécialisé en intérieur</strong>. Basé
                dans la région de Vannes, j'interviens sur vos projets de
                peinture et de décoration, sur du <strong>neuf</strong> comme
                sur de la <strong> rénovation</strong> avec sérieux, passion et
                souci du détail.
              </p>
              <br />
              <p>
                Après plusieurs années d'expérience sur le terrain, j'ai choisi
                de travailler en indépendant pour proposer un service{" "}
                <strong>plus humain</strong>, plus réactif, et entierement
                tourné vers vos besoins. Que ce soit pour un appartement, une
                maison ou un local professionnel, je mets un point d'honneur à{" "}
                <strong>fournir un travail soigné</strong>, dans le respect des
                délais et de vos envies.
              </p>
            </p>
          </div>
          {/* <div className="services-about-image">
            <img src={AboutImage} alt="À propos de moi" />
          </div> */}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Services;
